export const payload = {
  receiveMutation: 'RECEIVE_BILLABLETYPE',
  receivingMutation: 'RECEIVING_BILLABLETYPE',
  receiveMetadataMutation: 'RECEIVE_BILLABLETYPE_METADATA',
  savingMutation: 'SAVING_BILLABLETYPE',
  updatingMutation: 'UPDATING_BILLABLETYPE',
  deleteMutation: 'DELETE_BILLABLETYPE',
  deletingMutation: 'DELETING_BILLABLETYPE',
  incrementMutation: 'INCREMENT_BILLABLETYPE_COUNT',
  resetMetaMutation: 'RESET_BILLABLETYPE_META',
  clearMutation: 'CLEAR_BILLABLETYPE_STATE',
  moduleName: 'billabletype',
  endpoint: 'billabletypes',
  defaultModelGetter: 'getDefaultBillabletype',
  searchableFields: ['code', 'name', 'description']
}
